/**
 * Frontend logger utility
 * In production, console.log statements are conditionally executed
 * In development, all logs are shown
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  error: (...args) => {
    // Always log errors
    // console.error(...args);
  },

  warn: (...args) => {
    if (isDevelopment) {
      // console.warn(...args);
    }
  },

  info: (...args) => {
    if (isDevelopment) {
      // console.log(...args);
    }
  },

  debug: (...args) => {
    if (isDevelopment) {
      // console.log('[DEBUG]', ...args);
    }
  },

  log: (...args) => {
    if (isDevelopment) {
      // console.log(...args);
    }
  }
};

export default logger;

